var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8548 93.3463C64.5403 93.3463 81.3092 76.5774 81.3092 55.8919C81.3092 35.2064 64.5403 18.4375 43.8548 18.4375C23.1693 18.4375 6.40039 35.2064 6.40039 55.8919C6.40039 76.5774 23.1693 93.3463 43.8548 93.3463Z",
    fill: "#B0EF8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2313 82.4058L16.6953 51.6107L24.7141 38.5271L45.0989 54.9071L81.8327 11.1562L96.9727 27.2048L45.2313 82.4058Z",
    fill: "#009045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessful);
export default __webpack_public_path__ + "static/media/successful.da1bb0e493bc6aac4b9338ec351f65af.svg";
export { ForwardRef as ReactComponent };